import { render, staticRenderFns } from "./vantlist.vue?vue&type=template&id=22917eba&scoped=true&"
import script from "./vantlist.vue?vue&type=script&lang=js&"
export * from "./vantlist.vue?vue&type=script&lang=js&"
import style0 from "./vantlist.vue?vue&type=style&index=0&id=22917eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22917eba",
  null
  
)

export default component.exports